"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = _interopRequireDefault(require("./colors"));
const defaultTheme = {
  buttonShape: {
    default: '25px',
    square: '0'
  },
  colors: {
    ..._colors.default,
    loading: _colors.default.purple,
    inputBorder: _colors.default.grey[400],
    inputBorderFocused: _colors.default.secondary,
    inputText: _colors.default.textPrimary,
    primary: _colors.default.primary,
    primaryContrast: _colors.default.white,
    primaryDark: _colors.default.primaryDark,
    primaryHover: _colors.default.primaryHover,
    primaryLight: _colors.default.primaryLight,
    primaryLightest: _colors.default.primaryLightest,
    secondary: _colors.default.secondary,
    secondaryContrast: _colors.default.white,
    secondaryHover: _colors.default.secondary,
    redContrast: _colors.default.white,
    redHover: _colors.default.red,
    smurfBlue: '#00bbdc',
    smurfBlueContrast: _colors.default.black,
    smurfBlueLight: '#57ddf5',
    textBlack: _colors.default.black,
    textHint: _colors.default.grey[500],
    textHintDark: '#575757',
    textSecondary: _colors.default.primary,
    whiteContrast: _colors.default.black,
    yellow: '#f2eb9d'
  },
  fontSizes: {
    xxxSmall: '12px',
    xxSmall: '13px',
    xSmall: '14px',
    small: '15px',
    normal: '16px',
    large: '18px',
    xLarge: '20px',
    xxLarge: '24px',
    xxxLarge: '32px'
  },
  fonts: {
    globalFont: 'Graphik, arial, sans-serif',
    gtEesti: 'GT-Eesti, arial, sans-serif'
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  },
  lineHeights: {},
  letterSpacings: {},
  borderWidths: {},
  borderStyles: {},
  radii: {},
  shadows: {},
  zIndices: {},
  transitions: {}
};
var _default = exports.default = defaultTheme;